const firebaseConfig = {
  apiKey: 'AIzaSyBKYKMF6gUAMEn4w3iTlYtZBOUGZ4g1d-g',
  authDomain: 'cheeers.firebaseapp.com',
  projectId: 'cheeers',
  storageBucket: 'cheeers.appspot.com',
  messagingSenderId: '755231577882',
  appId: '1:755231577882:web:a6e7a8d113b866f82b7ea3',
  measurementId: 'G-7DG2CMMX6Y',
};

export const vapidKey =
  'BM6z-JPj3J_5UTZbQgaU5fqI59UR7RhC0eTpNn1ipl_6x6yR26La6caV58lc2OGjUXchivmKNkjCnrFdlHDAaeo';

export default firebaseConfig;
